import { SimpleThemeColor } from 'src/entities/enums'
import { cyup, fileTypeSets } from 'src/util/validation'
import * as yup from 'yup'
import { MoodCategoryFormData } from '.'

//@ts-ignore TODO FIXME
const validationSchema = yup.object().shape<MoodCategoryFormData>({
  name: yup.string().required().min(1),
  description: yup.string(),
  image_src: cyup.ensureFile({ validFileTypes: fileTypeSets.firebaseImage }),
  background_color: cyup.oneOfStringValue(SimpleThemeColor),
})

export default validationSchema
